var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-calendar-month")]),_c('v-btn',_vm._g({staticClass:"mx-1",attrs:{"outlined":"","small":"","color":"black","hide-details":""}},_vm.$listeners),[_c('span',[_vm._v(_vm._s(_vm.date))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }